import { render, staticRenderFns } from "./ProfileHeaderBackground.vue?vue&type=template&id=48dfe78a&scoped=true&"
import script from "./ProfileHeaderBackground.vue?vue&type=script&lang=ts&"
export * from "./ProfileHeaderBackground.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileHeaderBackground.vue?vue&type=style&index=0&id=48dfe78a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dfe78a",
  null
  
)

export default component.exports